import React, { useEffect, useState, useContext } from 'react'
import CommentModal from "./CommentModal";
import axios from 'axios';
import { serverInfo } from "../../App";
import Love from "../../Assets/Images/CreateAccount-page/love.png";
import Share from "../../Assets/Images/share.png";
import loveActive from "../../Assets/Images/loveActive.png";
import noImage from "../../Assets/Images/settings/no-image.png";
import "./VideoContent.css";
import ReactPlayer from "react-player";
import VideoPayModal from "./VideoPayModal";
import ShareModal from './ShareModal';
import getFormatCount from '../../CustomHelper/getFormatCount';
import VideoCommentList from './VideoCommentList';

function SingleVideo({ uploadVideo, paidLoveReact, currentUser }) {
  const [showModal, setShowModal] = useState(false);
  const [commentShowModal, setShowCommentModal] = useState(false);
  const [commentModalData, setCommentModalData] = useState([]);

  const [totalComment, setTotalComment] = useState(0);

  const [videoShare, setVideoShare] = useState(uploadVideo?.share_count ?? 0);
  const [showShareModal, setShowShareModal] = useState(false);

  const [totalReact, setTotalReact] = useState(0);
  const [userHasReacted, setUserHasReacted] = useState(false);

  const [modalPara, setModalPara] = useState([]);
  const [liked, setLiked] = useState(0);

  const { imageCdnUrl, videoCdnUrl } = useContext(serverInfo);

  const getVideFeedReact = videoId => {
    axios.get(`api/user/audition/video/react/total/${videoId}`).then(res => {
      if (res.data.status === 200) {
        const parseIntReact = Number(res.data.totalReact)
        setTotalReact(parseIntReact);
        setUserHasReacted(res.data.userHasReacted);
      }
    });
  };

  const getVideFeedComment = videoId => {
    axios.get(`api/user/audition/video/comment/total/${videoId}`).then(res => {
      if (res.data.status === 200) {
        setTotalComment(res.data?.totalComment);
      }
    });
  };

  const handleShareModal = () => {
    setShowShareModal(!showShareModal);
  }

  const handleCommentModal = (modalDart) => {
    setShowCommentModal(!commentShowModal);
    setCommentModalData(modalDart);
  }

  // Handle comment changes (optimistic update callback)
  const handleCommentChange = (isAdded, commentType) => {
    if (isAdded) {
      // Comment was added
      setTotalComment(prev => prev + 1);
    } else {
      // Comment was deleted
      setTotalComment(prev => Math.max(prev - 1, 0));
    }
  };

  function handleModal(value) {
    setModalPara(value.array);
    setShowModal(value.checking ? false : true);
  }

  useEffect(() => {
    getVideFeedReact(uploadVideo.id);
    getVideFeedComment(uploadVideo.id)
  }, [uploadVideo.id]);

  const loveIconActiveInactive = () => {
    return userHasReacted ? loveActive : Love
  };

  const handleReact = (react_num) => {
    let data = {
      videoId: react_num[0],
      reactNum: react_num[1],
      audition_id: react_num[3],
      round_id: react_num[4],
    };

    // Optimistic UI update
    setUserHasReacted((prev) => !prev);
    setTotalReact((prev) => prev + (userHasReacted ? -1 : 1));

    axios.post('api/user/audition/videos/loveReact', data).then((res) => {
      if (res.data.status === 200) {
        console.log('Reaction registered successfully');
      } else {
        setUserHasReacted((prev) => !prev);
        setTotalReact((prev) => prev + (userHasReacted ? -1 : 1));
      }
    });
  };

  const [showCommentList, setShowCommentList] = useState(false);

  const toggleCommentList = () => {
    setShowCommentList(prev => !prev);
  }

  return (
    <>
      <div className="container PostWidth align-items-center justify-content-center col-11 Enroll-Auditions">
        <div className="card PostCardBg ">
          <h2 className="accordion-header PostBack">
            <div className="d-flex justify-content-between">
              <div className="accordion-button-fx profile1-accordion-button PostBack  collapsed">
                <img
                  src={
                    uploadVideo?.user?.image != null
                      ? imageCdnUrl + uploadVideo?.user?.image
                      : noImage
                  }
                  className="PostImgHome"
                  alt="star-profile"
                />
                <span className="mx-2 text-warning text-light link-starPorfile">
                  {uploadVideo?.user?.first_name +
                    " " +
                    uploadVideo?.user?.last_name}
                  <br></br>
                </span>
              </div>
            </div>
          </h2>

          <div className="ViewPost">
            <div className="border-0 containerPostVideo">
              <div className="d-flex flex-column justify-content-end mx-3">
                <div>
                  <button
                    className="btnVideoStyle my-1"
                    onClick={() => {
                      handleReact([uploadVideo?.id, 1, uploadVideo?.audition_id, uploadVideo?.round_info_id]);
                    }}
                  >
                    <img
                      src={loveIconActiveInactive()}
                      width="30"
                      height="30"
                      alt=""
                    />
                  </button>
                  <p className="text-light text-center">Free</p>
                </div>

                {paidLoveReact.map((reactItem) => (
                  <div key={reactItem.id}>
                    <button
                      className="btnVideoStyle my-1"
                      onClick={() => {
                        let array = [
                          uploadVideo?.id,
                          reactItem?.loveReact,
                          reactItem?.fee,
                          reactItem?.paid_love_react_global_price
                        ];
                        const checking = uploadVideo?.get_total_react?.some(
                          (item) =>
                            item.react_num == reactItem?.loveReact
                        );

                        var value = {
                          array,
                          checking,
                        };
                        handleModal(value);
                      }}
                    >
                      <img
                        src={
                          uploadVideo?.get_total_react?.some(
                            (item) =>
                              item.react_num == reactItem?.loveReact
                          )
                            ? loveActive
                            : Love
                        }
                        width="30"
                        height="30"
                        alt=""
                      />
                    </button>
                    <p className="text-light text-center">
                      {reactItem?.loveReact}
                    </p>
                  </div>
                ))}
              </div>

              <div>
                <ReactPlayer
                  url={videoCdnUrl + uploadVideo.video}
                  className="Live-Video-x-video"
                  controls={true}
                  playing={false}
                  volume={1}
                />
              </div>

              <div className="d-flex flex-column justify-content-end mx-3">
                <div>
                  <button className="btnVideoStyle my-1">
                    <img
                      src={
                        (uploadVideo?.get_total_react).length > 0
                          ? loveActive
                          : Love
                      }
                      width="30"
                      height="30"
                      alt=""
                    />
                  </button>
                  <p className="text-light text-center">
                    {getFormatCount(totalReact)}
                  </p>
                </div>

                <div>
                  <button 
                    className="btnVideoStyle my-1" 
                    onClick={() => {
                      // handleCommentModal([uploadVideo?.id, uploadVideo?.audition_id, uploadVideo?.round_info_id]);
                      toggleCommentList();
                    }}
                  >
                    <i className="fa-solid fa-comment" style={{ fontSize: '30px' }}></i>
                  </button>
                  <p className="text-light text-center">
                    {totalComment}
                  </p>
                </div>

                <div>
                  <button className="btnVideoStyle my-1" onClick={handleShareModal}>
                    <img src={Share} width="30" height="30" alt="" />
                  </button>
                  <p className="text-light text-center">{videoShare > 0 ? videoShare : 0}</p>
                </div>
              </div>

              {showCommentList && (
                <VideoCommentList
                  imageCdnUrl={imageCdnUrl}
                  commentCount={totalComment}
                  featuredUser={uploadVideo?.user}
                  videoId={uploadVideo.id}
                  onCommentChange={handleCommentChange}
                  currentUser={currentUser}
                />
              )}
            </div>
          </div>
        </div>
      </div>

      <ShareModal
        show={showShareModal}
        onHide={() => setShowShareModal(false)}
        videoCdnUrl={videoCdnUrl}
        video={uploadVideo.video}
        onShare={setVideoShare}
        videoId={uploadVideo.id}
      />

      <CommentModal
        show={commentShowModal}
        onHide={() => setShowCommentModal(false)}
        commentModalData={commentModalData}
        getVideFeedComment={getVideFeedComment}
      />

      <VideoPayModal
        setLiked={setLiked}
        show={showModal}
        onHide={() => setShowModal(false)}
        modalPara={modalPara}
      />
    </>
  )
}

export default SingleVideo